import { FEATURE_FLAGS, useFlag } from '~/components/feature-flags';

export type TemplateLimit = { count: number; word: string };

/**
 * How many forms or templates of one kind a workspace or preset may name: five
 * where the effort selector's gate is on, three elsewhere. The server holds a
 * custom preset to the same cap (cara.CustomPresetTemplateRefsPerKind), so a
 * preset editor that offered more would fail to save.
 */
export const useTemplateLimit = (): TemplateLimit =>
  useFlag(FEATURE_FLAGS.EFFORT_LEVEL_SELECTOR)
    ? { count: 5, word: 'five' }
    : { count: 3, word: 'three' };

/**
 * The limit as a numeral, for JSX copy. A module-level constant such as
 * presetCustomFormPickerDescription cannot call the hook itself.
 */
export const TemplateLimitCount = () => <>{useTemplateLimit().count}</>;
